/**
 * Applies default styles to the template style object (defined in ui:style).
 * Applies the default properties only when not already defined in the template style object.
 * @param style
 * @param defaultStyle
 * @returns
 */
export const applyDefaultsToTemplateStyle = (
  templateStyle: React.CSSProperties | undefined,
  defaultStyle: React.CSSProperties,
) => {
  if (!templateStyle) {
    return defaultStyle;
  }

  const computedStyle: React.CSSProperties = {
    ...defaultStyle,
    ...templateStyle,
  };

  return computedStyle;
};
